import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from './notification.service';

@Injectable({
  providedIn: 'root'
})
export class SalaryValidationErrorService {

  constructor(private notificationService: NotificationService) {}

  isSalaryValidationError(err: HttpErrorResponse): boolean {
    return err.status === 422 && Array.isArray(err.error?.salariosNoActualizados);
  }

  handleSalaryValidationError(err: HttpErrorResponse): void {
    const items: any[] = err.error?.salariosNoActualizados || [];

    const rows = items.map(item => {
      const periodos = item.periodosFaltantes.join(', ');
      return `<li><strong>${item.nombre}</strong> &middot; ${item.cargo}<br>Períodos faltantes: ${periodos}</li>`;
    }).join('');

    const message =
      `<ul>${rows}</ul>` +
      `<p>Comuníquese con el director financiero para registrar los salarios faltantes.</p>`;

    this.notificationService.alert('Salarios no actualizados', message, 'warning');
  }
}
